import store from '@/store'

export function getItemHeader(item, name = '') {
  const pointIcon = item.icon_id ? store.getters['pointIcon/getPointIcon'](item.icon_id) : null
  return pointIcon?.name ?? name
}
